import BaseSettingsApi, { IBasePortalSettings, IBaseStandardPortalConfig } from 'api/digifi/base/BaseSettingsApi';

interface IIntermediaryPortalConfiguration extends IBaseStandardPortalConfig {
  allowInviteBorrowers: boolean;
}

export interface IIntermediaryPortalSettings extends IBasePortalSettings {
  portalConfiguration: IIntermediaryPortalConfiguration;
}

export default class IntermediarySettingsApi extends BaseSettingsApi<IIntermediaryPortalSettings> {}
